import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import axios from 'axios';
import BASE_API_URL from '../apis/index';
import { styled } from 'styled-components';
import UserProductRegistrationForm from '../components/UserProductRegistrationForm';

export default function UserProductEdit() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const prodId = queryParams.get("prodId");

    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);

    // fetch product Details
    useEffect(() => {
        if (!prodId) return;

        const fetchProduct = async () => {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(
                    `${BASE_API_URL}/api/seller/product/${prodId}`,
                    { params: { prodId }, headers: { Authorization: `Bearer ${authToken}` } }
                );

                const product = res.data;

                // parse existing documents & names
                const existingDocs = product.supporting_documents ? JSON.parse(product.supporting_documents) : [];
                const existingDocNames = product.document_names ? JSON.parse(product.document_names) : [];

                // merge into objects {file, name}
                const mergedExistingDocs = existingDocs.map((file, i) => ({
                    file,
                    name: existingDocNames[i] || file
                }));

                // 🔹 Transform API response into formData format
                setFormData({
                    product_id: product.id,
                    productName: product.product_name || "",
                    description: product.product_description || "",
                    category: product.category || "",
                    tech_details: product.tech_details || "",
                    productType: product.product_type || "",
                    concentration: product.concentration || "",
                    source: product.source || "",
                    formats: product.formats || "",
                    pricing: Number(product.pricing) || null,
                    minPrice: Number(product.min_price) || null,
                    maxPrice: Number(product.max_price) || null,
                    currency: product.currency || "INR",
                    moq: parseFloat(product.moq.split(" ")[0]) || 0,
                    moqUnit: product.moq.split(" ")[1],
                    tiered_pricing: JSON.parse(product.tiered_pricing),

                    features: product.features ? JSON.parse(product.features) : [],
                    grades: product.grades ? JSON.parse(product.grades) : [],
                    coas: null, // new upload
                    existingCoas: product.coas || null, // existing coa filename
                    existingImages: product.product_images ? JSON.parse(product.product_images) : [],
                    existingDocuments: mergedExistingDocs,

                    company_id: product.company_id,
                    company_name: product.company_name,
                    company_type:
                        (!product.company_type || product.company_type.trim() === "")
                            ? "Ingredient Manufacturer"
                            : product.company_type,
                });
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [prodId]);

    if (loading) return <p>Loading...</p>;
    if (!formData) return <p>No product data found</p>;

    return (
        <MainWrapper className="container">
            <Breadcrumbs aria-label="breadcrumb" className="mb-5 mt-2 pageBreadCrumbs">
                <Link color="inherit" href={`/user-company-details?compId=${formData.company_id}`}> {formData.company_name} </Link>
                <Link color="inherit" href={`/user-product-details?prodId=${formData.product_id}`}> {formData.productName} </Link>
                <Typography sx={{ color: "text.primary" }}> Editing product </Typography>
            </Breadcrumbs>

            <h2 className="pageTitle after_title_line"> Edit Product <span className="txt_color_secondary">{formData.productName} ({formData.company_type})</span> </h2>

            <UserProductRegistrationForm
                compId={formData.company_id}
                compName={formData.company_name}
                initialFormData={formData}
                mode="edit"
            />
        </MainWrapper>
    );
}
const MainWrapper = styled.div``;

